import productListService from './productListService'

export default productListService



// WEBPACK FOOTER //
// ../src/services/productListService/index.js